module.exports = __webpack_public_path__ + "static/img/bookmarks.c77cdc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookmarks.png
// module id = 8+na
// module chunks = 1